import { Component, OnInit, Inject } from '@angular/core';
import { UsuarioService, DadosService, MensagemService } from '../services/service';
import { Router, ActivatedRoute } from '@angular/router';
import { Md5 } from 'ts-md5/dist/md5';
import { nomesEmpresas } from './nomes_empresas';
import { Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  error: string;

  loading: Boolean = false;

  constructor(private usuarioService: UsuarioService,
    private router: Router,
    private route: ActivatedRoute,
    private empresaService: DadosService,
    private title: Title,
    private mensagemService: MensagemService,
    @Inject(DOCUMENT) private _document: HTMLDocument) {

    var cnpj = this.route.parent.snapshot.params['id'];
    nomesEmpresas.forEach(element => {
      if (element.cnpj == cnpj) {
        //ALTERA O TITULO DA ABA PARA O NOME DA EMPRESA
        this.title.setTitle(element.descricao);
        //ALTERANDO ICONE DA ABA CONFORME EMPRESA
        this._document.getElementById('appFavicon').setAttribute('href', 'assets/img/ic_' + cnpj.trim() + '.png');
        console.log('assets/img/ic_' + cnpj.trim() + '.png');
      }
    });
  }

  ngOnInit() {
    if (this.usuarioService.getUsuarioLogado()) {
      this.router.navigate([this.route.parent.snapshot.params['id'], 'adm']);
    }
  }

  getLogo() {
    return "assets/img/" + this.empresaService.getEmpresa().cnpj_sem_mascara + ".png";
  }

  logar(login: any, event: any) {
    this.loading = true;
    login.senha = Md5.hashStr(login.senha).toString();
    var usr = String(login.usuario);
    usr = String(this.retiraFormatacao(usr));


    if (usr.length > 11) {
      login.usuario = this.formataCNPJ(usr);
    } else {
      login.usuario = this.formataCPF(usr);
    }

    this.usuarioService.logar(login)
      .subscribe((result) => {
        if (result) {
          // login success
          var usuario  = this.usuarioService.getUsuarioLogado();
          var caminho = localStorage.getItem('currentURL');
          localStorage.setItem('currentURL',"");
          if ((caminho) && (caminho.indexOf('/login') < 0)) {
            var array = caminho.split('/');
            array.splice(0, 1);
            if (caminho.indexOf('cadastro-usuario/novo') > 0) {
              //var usuario  = this.usuarioService.getUsuarioLogado();
              usuario.perfil = 'R';
              localStorage.setItem('currentUser',JSON.stringify(usuario));
            }
            this.router.navigate(array);
          } else {
            this.router.navigate([this.empresaService.getEmpresa().cnpj_sem_mascara, 'adm']);
          }

          this.loading = false;
        } else {
          // login failed
          this.error = 'Usuário ou Senha esta incorreta!';
          this.loading = false;
        }

      }, (error) => {
        this.error = JSON.parse(error._body).erro;
        this.loading = false;
      })
  }

  formataCPF(valor: string) {
    return valor.substr(0, 3) + '.' +
      valor.substr(3, 3) + '.' +
      valor.substr(6, 3) + '-' +
      valor.substr(9, 2);
  }

  formataCNPJ(valor: string) {
    return valor.substr(0, 2) + '.' +
      valor.substr(2, 3) + '.' +
      valor.substr(5, 3) + '/' +
      valor.substr(8, 4) + '-' +
      valor.substr(12, 2);
  }

  retiraFormatacao(valor: string) {
    var ret = valor.replace(".", "");
    ret = ret.replace(".", "");
    ret = ret.replace("-", "");
    ret = ret.replace("/", "");
    return ret;
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts